var $fd75d77379af10ab$exports = {};
$fd75d77379af10ab$exports = {
    "collectionLabel": `Soovitused`
};


export {$fd75d77379af10ab$exports as default};
//# sourceMappingURL=et-EE.mjs.map
